import React, {
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';
import AddToBagButton from '../AddToBagButton/AddToBagButton';
import MemberEarlyAccessButton from '../MemberEarlyAccessButton/MemberEarlyAccessButton';
import SizeTileSection from '../SizeTileSection/SizeTileSection';
import UrgencyMessage from '../UrgencyMessage/UrgencyMessage';
import FinalSale from '../FinalSale/FinalSale';
import HorizontalLineSeparator from '../HorizontalSeparator/HorizontalSeparator';

export default function StickyAddToBagManager({
  handleAddToBag,
  activeButtonLabel,
  primarySizeTileHandler,
  secondarySizeTileHandler,
  setSizeGuideOpen,
  hasGatedAddToBagExperience,
  atbLabelText,
}) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    collectionData,
    tmntData,
  } = ProductPageState;

  const [stickySizeTrayVisible, setStickySizeTrayVisible] = useState(false);
  const [isOverlappingFooter, setIsOverlappingFooter] = useState(false);
  const stickyContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('#catalog-mfe-web-service-FooterFrontend');

      if (footer && stickyContainerRef.current) {
        const footerRect = footer.getBoundingClientRect();
        const stickyRect = stickyContainerRef.current.getBoundingClientRect();

        if (stickyRect.bottom > footerRect.top) {
          setIsOverlappingFooter(true);
        } else {
          setIsOverlappingFooter(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (collectionData.stickySizeSelectionCompleted && stickySizeTrayVisible) {
    setStickySizeTrayVisible(false);
    handleAddToBag();
  }

  const stickyAddToBagClick = () => {
    if (collectionData.hasQualifiedSku) {
      handleAddToBag();
    } else {
      setStickySizeTrayVisible(true);
    }
  };

  const isFinalSale = collectionData?.activeProduct?.isFinalSale;
  const hasHorizontalSeparator = isFinalSale || collectionData.showUrgencyMessage;
  const stickyATBContainerStyle = isOverlappingFooter ? { visibility: 'hidden' } : { visibility: 'visible' };

  return (
    <>
      <div
        className="mfe-sticky-add-to-bag-container"
        data-testid="sticky-atb-container"
        style={stickyATBContainerStyle}
      >
        {stickySizeTrayVisible && (
          <>
            <div className="mfe-sticky-size-tray" data-testid="sticky-size-tray">
              <UrgencyMessage
                urgencyMessage={tmntData.swatchUrgencyMessage?.value}
                showUrgencyMessage={collectionData.showUrgencyMessage}
                rerenderKey={collectionData.activeProduct.productId}
              />
              {isFinalSale && (
                <FinalSale
                  finalSaleMessage={ProductPageState.tmntData?.finalSaleText?.value}
                />
              )}
              {hasHorizontalSeparator && (
                <HorizontalLineSeparator />
              )}
              <SizeTileSection
                primarySizeTileHandler={primarySizeTileHandler}
                secondarySizeTileHandler={secondarySizeTileHandler}
                setSizeGuideOpen={setSizeGuideOpen}
              />
            </div>
            <button aria-label={tmntData?.closeText?.value} className="mfe-sticky-size-tray-overlay" onClick={() => setStickySizeTrayVisible(false)} />
          </>
        )}
        {hasGatedAddToBagExperience
          ? <MemberEarlyAccessButton /> : (!stickySizeTrayVisible && (
          <AddToBagButton
            brand={collectionData.activeProduct.brand}
            label={tmntData?.[atbLabelText]?.value}
            handleAddToBag={stickyAddToBagClick}
            activeButtonLabel={activeButtonLabel}
          />
          ))}
      </div>
      <div
        className="mfe-sticky-add-to-bag-container"
        id="atb-shadow-sticky"
        data-testid="atb-shadow-sticky"
        ref={stickyContainerRef}
      />
    </>
  );
}
